import styled from 'styled-components';
import BaseButton from './baseButton';

export const BrandButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.buttons.brandButton.default.background};
  color: ${({ theme }) => theme.buttons.brandButton.default.font};
  &:hover {
    background-color: ${({ theme }) => theme.buttons.brandButton.hovered.background};
  }
  &:focus {
    background-color: ${({ theme }) => theme.buttons.brandButton.focused.background};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.buttons.brandButton.disabled.font};
    background-color: ${({ theme }) => theme.buttons.brandButton.disabled.background};
  }
`;
